

import removeEventListener from 'dom-helpers/events/off';
import addDomEventListener from 'dom-helpers/events/on';

import KeyCode from './utils/keyCode';
import type { KeyboardEvent } from 'react';

export interface AddEventLReturn {
    remove: () => void
}


export const stopKeyEventBubbles = (event: KeyboardEvent<HTMLInputElement>) => {
    const { LEFT, RIGHT, UP, DOWN, ENTER, ESC } = KeyCode;
    if ([LEFT, RIGHT, UP, DOWN, ENTER, ESC].includes(event.keyCode)) {
        // event.nativeEvent.stopPropagation();
        // event.nativeEvent.stopImmediatePropagation();
        event.stopPropagation();
    }
}

export type EventHandlerType = (event: MouseEvent | TouchEvent | FocusEvent | KeyboardEvent | Event) => void;

export function addEventListener<K extends keyof HTMLElementEventMap>(
    node: Element | Document | Window,
    event: K,
    handler: EventHandlerType,
    capture?: boolean
): AddEventLReturn {
    addDomEventListener(node, event, handler, capture);

    return {
        remove() {
            removeEventListener(node, event, handler, capture);
        }
    };
}

export function addFocusListener(handler: () => void) {
    let useFocusin = !document.addEventListener;
    let remove;

    if (useFocusin) {
        (document as any).attachEvent('onfocusin', handler);
        remove = () => (document as any).detachEvent('onfocusin', handler);
    } else {
        document.addEventListener('focus', handler, true);
        remove = () => document.removeEventListener('focus', handler, true);
    }

    return {remove};
}